import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Link, Location } from '@reach/router'
import cx from 'classnames'

import {
  detectLocaleFromPath,
  stripLocalePrefix,
  localePath,
} from '../helpers/locale'
import { setLanguage } from '../state/language'
import globe from '../graphics/globe.svg'

// Labels are written in the target language on purpose.
const TARGETS = {
  da: { locale: 'en', label: 'English' },
  en: { locale: 'da', label: 'Dansk' },
}

const TARGET_OPTIONS = Object.values(TARGETS)

export default function LanguageSwitcher({ className }) {
  const [isOpen, setIsOpen] = useState(false)
  const containerRef = useRef(null)

  useEffect(() => {
    if (!isOpen) return undefined

    const handleClickOutside = (event) => {
      if (!containerRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('click', handleClickOutside)
    return () => document.removeEventListener('click', handleClickOutside)
  }, [isOpen])

  return (
    <Location>
      {({ location }) => {
        const currentLocale = detectLocaleFromPath(location.pathname)
        const pathWithoutLocale = stripLocalePrefix(location.pathname)

        return (
          <div ref={containerRef} className={cx('relative dib', className)}>
            <button
              type="button"
              aria-label="Select language"
              aria-expanded={isOpen}
              className="mt1 mb1 ph1 pa0 bn bg-transparent pointer db flex items-center navy link"
              onClick={() => setIsOpen((open) => !open)}
            >
              {/* <img src={globe} height={20} width={20} alt="" className="mr1" /> */}
              <span className="ttu dn db-ns ">{currentLocale}</span>
              <img
                src={globe}
                height={20}
                width={20}
                alt=""
                className="ml1-ns"
              />
            </button>
            {isOpen && (
              <ul className="absolute right-0 z-1 list mv0 mt2 pl0 bg-white ba b--silver shadow-4 br2 nowrap">
                {TARGET_OPTIONS.map((target) => (
                  <li key={target.locale}>
                    <Link
                      to={
                        localePath(pathWithoutLocale, target.locale) +
                        location.search
                      }
                      aria-current={
                        target.locale === currentLocale ? 'page' : undefined
                      }
                      className={cx(
                        'w-100-ns link navy ph3 pv2 flex justify-between-ns hover-bg-near-white',
                        {
                          fw7: target.locale === currentLocale,
                        }
                      )}
                      onClick={() => {
                        setLanguage(target.locale)
                        setIsOpen(false)
                      }}
                    >
                      <span className="w-30-ns ttu mr2 pr2 br b--light-blue">
                        {target.locale}
                      </span>
                      <span className="w-70-ns">{target.label}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )
      }}
    </Location>
  )
}

LanguageSwitcher.propTypes = {
  className: PropTypes.string,
}
